import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';
import { EXPANDED, SHRUNK } from '../../reducers/trayState';

export default () => {
  const { colors, breakpoints, spacing, borderRadius, heights } = useTheme();

  return {
    topSpacer: headerHeight => css`
      position: relative;
      height: 100vh;
      overflow: hidden;

      @media screen and (max-width: 1023px) {
        display: flex;
        flex-direction: column;
        min-height: -webkit-fill-available;

        @supports (height: 100dvh) {
          height: 100dvh;
        }
      }

      ${breakpoints.l} {
        padding-top: ${headerHeight};
      }
    `,
    base: isListView => css`
      position: relative;
      height: 100%;
      display: grid;
      justify-content: center;
      grid-template-areas:
        'header'
        'map'
        'results';
      grid-template-rows: auto 1fr auto;
      grid-template-columns: 1fr;

      @media screen and (max-width: 1023px) {
        flex: 1 1 auto;
        min-height: 0;
        height: auto;
      }

      ${breakpoints.lg} {
        grid-template-areas:
          'header map'
          'results map';
        grid-template-columns: min(50%, 375px) 1fr;
      }

      ${breakpoints.lg} {
        grid-template-columns: 375px 1fr;
      }

      ${!isListView &&
      css`
        ${breakpoints.l} {
          grid-template-areas:
            'header map'
            'results map';
        }
      `}
    `,
    header: headerHeight => css`
      grid-area: header;
      padding: ${spacing.s};
      background: ${colors.white};
      margin-top: ${heights.filterNav};
      border-top: 1px solid ${colors.lightGrey};
      border-bottom: 1px solid ${colors.lightGrey};

      ${breakpoints.m} {
        // remove it once header changes are completed.
        // margin-top: calc(${headerHeight} + ${heights.filterNav});
        margin-top: ${heights.mainNav.desktop};
      }

      ${breakpoints.l} {
        margin-top: ${headerHeight};
      }
    `,
    backLink: css`
      color: ${colors.navy};
      &:focus {
        outline: 0;
        p {
          text-decoration: underline;
        }
      }
    `,
    headerTitle: css`
      display: inline-block;
    `,
    mapAreaWrapper: headerHeight => css`
      flex: 1;
      margin: 0;
      order: 2;
      grid-area: map;
    `,
    providerCardWrapper: (isListView, trayState, headerHeight) => css`
      padding: 1rem 0;
      overflow: hidden;
      position: relative;
      grid-area: results;
      height: 6.875rem;
      background: ${colors.lightGrey};
      border-radius: 1rem 1rem 0 0;
      align-items: center;
      background-color: ${colors.lightGrey};
      transition: all 0.2s ease-in-out;
      box-shadow: 0 -4px 20px 0 rgba(0, 0, 0, 0.16);

      ${trayState === EXPANDED &&
      css`
        height: auto;
        max-height: calc(100vh - 8rem);

        @supports (height: 100dvh) {
          max-height: calc(100dvh - 8rem);
        }
      `}

      ${trayState === SHRUNK &&
      css`
        height: 6.875rem;
      `}

      ${breakpoints.lg} {
        height: calc(100% - 4rem);
        margin-top: 0;
        border-radius: 0;
        z-index: unset;
        overflow: auto;
      }

      ${breakpoints.lg} {
        box-shadow: none;
      }

      ${!isListView &&
      css`
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        ${trayState === EXPANDED &&
        css`
          height: auto;
          max-height: calc(100vh - 8rem);

          @supports (height: 100dvh) {
            max-height: calc(100dvh - 8rem);
          }
        `}

        ${trayState === SHRUNK &&
        css`
          height: 6.875rem;
        `}

        ${breakpoints.lg} {
          position: relative;
          bottom: unset;
          left: unset;
          border-radius: 0;
          height: calc(100% - 4rem);
        }
      `}
    `,

    btnWrapper: css`
      padding: ${spacing.s} 0rem 1.5rem 0rem;
      width: 100%;
      ${breakpoints.lg} {
        padding: ${spacing.s} 1rem 1.5rem 1rem;
      }
    `,

    scrollContainer: (isListView, trayState) => css`
      position: relative;
      height: 90%;

      @media screen and (max-width: 1023px) {
        display: ${trayState === EXPANDED ? 'block' : 'none'};
        height: auto;
      }
    `,
    providerCards: isListView => css`
      display: flex;
      flex-direction: row;
      gap: 1rem;
      overflow-x: auto;
      overflow-y: hidden;
      border-radius: ${borderRadius.l};
      padding: 1rem 1rem 0;
      scroll-snap-type: x mandatory;
      scroll-behavior: auto;
      flex-wrap: nowrap;
      ${breakpoints.lg} {
        flex-direction: column;
        flex-wrap: wrap;
        padding: 1rem;
      }

      ${!isListView &&
      css`
        overflow-y: hidden;
      `}
    `,
    resultCard: css`
      border: ${borderRadius.m} solid ${colors.red};

      &:hover,
      &:focus {
        outline: 0;
        border: ${borderRadius.m} solid ${colors.navy};
      }
    `,
    totalResults: isListView => css`
      display: block;
      padding-bottom: 1rem;
      text-align: center;
      position: relative;

      span {
        position: relative;
        display: block;
        text-align: center;
        &:before {
          display: block;
          content: '';
          width: 5rem;
          height: 0.25rem;
          background: #5b6885;
          margin: 0 auto;
          margin-bottom: 1rem;
          border-radius: ${borderRadius.s};
          ${breakpoints.lg} {
            display: none;
          }
        }
      }

      ${breakpoints.lg} {
        padding-bottom: 1.5rem;
        text-align: start;
        &.resultsOpportunity {
          padding-left: 1rem;
        }
        span {
          padding-top: 0;
          border-top: 0;
        }
      }

      ${breakpoints.lg} {
        display: block;
      }

      ${isListView &&
      css`
        // display: block;
      `}
    `,
    primaryBtn: css`
      background-color: ${colors.blue};
      color: ${colors.white};
      border-radius: 50px;
      font-size: 14px;
      line-height: 18px;
      padding: 10px;
      font-weight: 400;
      text-transform: uppercase;
    `,
    backToWrapper: css`
      position: absolute;
      right: 10px;
      top: -3rem;
      z-index: 100;

      ${breakpoints.l} {
        display: none;
      }
    `,
    arrowRotate: css`
      transform: rotate(180deg);
      margin-right: 5px;
    `,
    loadMore: isListView => css`
      margin: 0 ${spacing.xs};
      p {
        color: #e1261c;
      }

      ${!isListView &&
      css`
        display: none;

        ${breakpoints.l} {
          display: block;
        }
      `}
    `,
    loader: css`
      margin-top: ${spacing.s};
      margin-bottom: ${spacing.s};
    `,
    noOppOpenFilterDiv: filterShowHide => css`
      display: ${filterShowHide ? 'none' : 'flex'};
      flex-direction: column;
      width: 100%;
      background: #fff;
      border-radius: 0.5rem;
      padding: 1rem;
      @media (min-width: 767px) {
        background: transparent;
        border-radius: 0px;
        padding: 0rem;
        width: 100%;
        display: flex;
        flex-direction: column;
      }
    `,
    noResultsWrapper: css`
      padding: 1rem 1rem;
      ${breakpoints.m} {
        padding: 1rem 2rem;
      }
    `,
    loadMoreCardContainer: css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;
      padding: 1rem;
      border-radius: 0.5rem;
      flex: 0 0 85%;
      width: 100%;
      scroll-snap-align: center;
    `,
    cardContainer: isMobile => css`
      width: 100%;
      ${isMobile &&
      css`
        display: flex;
        flex: 0 0 85%;
        scroll-snap-align: center;
        scroll-snap-stop: always;
      `}
    `,
    dotsContainer: css`
      display: flex;
      gap: 0.75rem;
      justify-content: center;
      margin-top: 1rem;
    `,
    dots: (i, activeDot) => css`
      width: 0.625rem;
      height: 0.625rem;
      border-radius: 70%;
      background: ${i === activeDot ? '#00539F' : '#5B6885'};
      transition: background-color 0.3s ease;
      opacity: ${i === activeDot ? 'unset' : '0.5'};
    `,
  };
};
